var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAftmb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABJlBMVEUAAAC9xdG9xdG9xdG9 xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG9xdG8 xdG8xNG/xtLGzdjGzde+xtLJz9nW2+LS2ODT2ODV2uLIz9nCydXHztjDy9XEy9bU2uHQ1t7P1d7U 2eHFzNbDytXByNTf4+nM0tu8xNDO1N3e4ui/x9Ld4ujP1N3ByNPBydTQ1d7c4ee/x9PN09zX3OPA yNPX2+PW2+Pn6u7m6e7V2+LCytXR19/Q1t/CydTY3OTK0Nq7xNDL0dvk6Ozj5+zg5OnJ0NrK0drf 4+jS19/IztjM0tzL0drDy9bl6O3S1+DV2uHJ0Nnb4ObEzNa+xtHM09zHzdi+xdHFzNf///9MNmsl AAAAFnRSTlMAAAIpbK3Z8v0BN5ff/BmJ6jXCQdqK8RfsjAAAAAFiS0dEYbKwTIYAAAAHdElNRQfm AwgCKRo0fbL/AAAB+klEQVQ4y4WTW2PSMBSAMy4Fym0MPATJQosbrjWsYVVhlFmnDDdUpvOyzXn7 /7/CpE3a7sWdBzg5+ZpzR0jKlpBcvlA0SuVyySgW8jlpQYmIQ8Ws1uqgpF6rmpUMIdRGcxvuyXaz kRBCae3oi25XazstRYi/tqGMuPe4T7A6GO2IkN931DXZpQPLHoJ45Yk4d6I3hH/9/p492O/CyHra BzhwpJeGBCrN+Hrkus9ire9ajNCR0JoVAZhx/ONDDyvvHCZH/pDJXMwtlKvGVvacvnjJo1CmM3o8 ja3VHMrXFODOg0Uw5/xk8sqbuwqo5VGhrgEQd6HjhMEJBw3UC6gICQB4f/H69M1bEYoGoIiMBMBs SfcCb0jPVilgoJIG3s3Cc3IRrC9669BZaKCEyhp4PyEceLAWP73Zh7Eyl1PgI90QLAFMLsNPKZC4 cNln+wq+fIVdumRu6sLIZDGyLNt1B98gG2Q2TQ7B6XcP83tpZgrVZdc3w1t7KQqRKVRa6tUZvSWc ixBnq0yp42b5hB3SdS9qJ/a98ChtVtRufn7pHwfAVbuJ88OPR9eUA/NIaHd0PF3S4U8sB29DD1QZ ooGJR27zS2Zp/4Y/V/Y1U6Mdj5wYWl0L+Ove2NadPhktPdbtjt4KYCzZnU47XYx0cVJJFufh1Xt4 ef+7/v8AUnRjIOM0HUEAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDMtMDhUMDI6NDE6MjYrMDA6 MDDsOykkAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAzLTA4VDAyOjQxOjI2KzAwOjAwnWaRmAAA AABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAftmb);
export default __webpack_public_path__ + "static/media/aftmb.3aefe203.svg";
export { ForwardRef as ReactComponent };